import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { Employee360SchemaObject } from '../Employee360Schema';
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _, { set } from 'lodash';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Box from "@material-ui/core/Box";
import { makeStyles } from '@material-ui/core';
import zIndex from "@material-ui/core/styles/zIndex";
import MessageModal from "../../../../UI/Modal/MessageModal";
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

const useStyles = makeStyles((theme) => ({
    stickyHeader: {
        position: 'sticky',
        left: 0,
        zIndex: 1,
        backgroundColor: 'white',
    },
    stickyColumn: {
        position: 'sticky',
        left: 0,
        zIndex: 1,
        backgroundColor: 'white',
    },
    sticky: {
        position: 'sticky',
        left: 0,
        top: 0,
        background: 'white',
        zIndex: 1,
    },
}));



const screenCode = "EMPLOYEE360REPORT";

export function Employee360Listing(props) {

    const componentRef = useRef();
    const classes = useStyles();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [pluckingTransactionDate, setPluckingTransactionDate] = useState("");
    const [sundryTransactionDate, setSundryTransactionDate] = useState("");
    const [isTableHide, setIsTableHide] = useState(true);
    const [chipData, setChipData] = useState([]);
    const [monthlyCollectionDetails, setMonthlyCollectionDetails] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        fromDate: new Date().toISOString().split('T')[0],
        toDate: new Date().toISOString().split('T')[0],
        regNumber: "",
        employeeType: "0"
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        fromDate: "",
        toDate: "",
        regNumber: "",
        employeeType: "0"
    });

    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "",
        disciption: "",
    });

    const csvHeaders = [
        { label: "Date", value: "date" },
        { label: "Emp.Name", value: "employeeName" },
        { label: "Emp.Type", value: "employeeTypeName" },
        { label: "In Time", value: "inTime" },
        { label: "Out Time", value: "outTime" },
        { label: "Job Type", value: "jobType" },
        { label: "Job Code", value: "jobCode" },
        { label: "Session 1 Quantity", value: "Session 1 Q" },
        { label: "Session 1 Operator", value: "Session 1 U" },
        { label: "Session 2 Quantity", value: "Session 2 Q" },
        { label: "Session 2 Operator", value: "Session 2 U" },
        { label: "Session 3 Quantity", value: "Session 3 Q" },
        { label: "Session 3 Operator", value: "Session 3 U" },
        { label: "OT Hours", value: "otHours" }
    ];

    const sessionHeaders = [
        { label: "Session 1 Quantity", value: "Session 1 Q" },
        { label: "Operator", value: "Session 1 U" },
        { label: "Session 2 Quantity", value: "Session 2 Q" },
        { label: "Operator", value: "Session 2 U" },
        { label: "Session 3 Quantity", value: "Session 3 Q" },
        { label: "Operator", value: "Session 3 U" }
    ];

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [toDate, setToDate] = useState({
        min: '',
        max: ''
    });

    const schema = Joi.object(Employee360SchemaObject).options({ allowUnknown: true });
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
        )
        setIsTableHide(true);
    }, [monthlyCollectionDetails.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown()
        )
        setIsTableHide(true);
    }, [monthlyCollectionDetails.estateID])


    useEffect(() => {
        setIsTableHide(true);
    }, [monthlyCollectionDetails.employeeType]);

    useEffect(() => {
        setIsTableHide(true);
    }, [monthlyCollectionDetails])

    function handleGroupChange(target) {
        validateInputs(target);

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            groupID: target.value,
            estateID: "0",
        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            estateID: target.value,
            divisionID: "0",
            regNumber: "",
            employeeType: "0",
            fromDate: new Date().toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0],
        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            divisionID: target.value,
            regNumber: "",
            employeeType: "0",
            fromDate: new Date().toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0],
        });
    }

    function handleFromDateChange(target) {
        const selectedFromDate = target.value;
        validateInputs(target);

        const date = new Date(selectedFromDate);
        const start = new Date(date.getFullYear(), date.getMonth(), 1);
        const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        setToDate({
            min: start.toISOString().split('T')[0],
            max: end.toISOString().split('T')[0]
        });
        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            fromDate: target.value
        });
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            toDate: target.value
        });
    }

    function handleregNumber(target) {
        validateInputs(target);

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            regNumber: target.value
        });
    }

    function handleEmployeeTypeChange(target) {
        validateInputs(target);

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            employeeType: target.value
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, Employee360SchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEMPLOYEE360REPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromTokenV2();
        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }
            setMultipleEstates(estateArray)
            setMonthlyCollectionDetails({
                ...monthlyCollectionDetails,
                groupID: token.groupID
            });
        }
        else {
            setMonthlyCollectionDetails({
                ...monthlyCollectionDetails,
                groupID: token.groupID,
                estateID: token.operationEntityID
            });
        }

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(monthlyCollectionDetails.groupID);
        setEstates(data);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(monthlyCollectionDetails.estateID);
        setDivisions(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    } function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    async function handleSearch(e) {
        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, monthlyCollectionDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const result = await services.getEmployee360ReportData(monthlyCollectionDetails);

        createTableData(result)
        getSelectedDropdownValuesForReport(monthlyCollectionDetails);

        if (Array.isArray(result)) {
            const pluckingObj = result.find(
                x => x.pluckingTransactionDate && x.pluckingTransactionDate !== "0001-01-01T00:00:00"
            );
            const pluckingDate = pluckingObj
                ? new Date(pluckingObj.pluckingTransactionDate).toLocaleDateString()
                : "";

            setPluckingTransactionDate(pluckingDate);

            const sundryObj = result.find(
                x => x.sundryTransactionDate && x.sundryTransactionDate !== "0001-01-01T00:00:00"
            );
            const sundryDate = sundryObj
                ? new Date(sundryObj.sundryTransactionDate).toLocaleDateString()
                : "";

            setSundryTransactionDate(sundryDate);

            setChipData([pluckingDate, sundryDate]);
        }

        if (result.length != 0) {
            setIsTableHide(false);
            createDataTable();
        }
        else {
            setMessageModel({
                ...messageModel,
                hidden: false,
                type: "Error",
                disciption: "No Records To Display",
            });
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
        }
    }

    function createTableData(data) {
        var copyData = _.cloneDeep(data);
        let result = [];
        copyData.forEach(x => {
            if (x.isPlucking == true) {
                var dateOne = x.date.split('T')[0];
                var duplicateData = result.find((y) => y.date.split('T')[0] === dateOne && y.isPlucking == true);
                if (duplicateData) {
                    duplicateData[x.sessionName + ' Q'] = duplicateData[x.sessionName + ' Q'] == undefined ? 0 + x.totalAmount
                        : duplicateData[x.sessionName + ' Q'] + x.totalAmount;
                    duplicateData[x.sessionName + ' U'] = x.userName
                    duplicateData.date = dateOne;
                    duplicateData.employeeID = x.employeeID;
                    duplicateData.employeeName = x.employeeName;
                    duplicateData.divisionName = x.divisionName;
                    duplicateData.employeeTypeName = x.employeeTypeName;
                    duplicateData.jobCode = x.jobCode;
                    duplicateData.jobType = x.jobType === "1" ? 'General' : x.jobType === "2" ? 'Cash' : x.jobType === "3" ? 'OT' : x.jobType === "RSM" ? 'Outgrower' : x.jobType; duplicateData.outTime = new Date(x.inTime).toLocaleTimeString('en-US');
                    duplicateData.registrationNumber = x.registrationNumber;
                    duplicateData.otHours = x.otHours;
                    duplicateData.allTotal = duplicateData.allTotal + x.totalAmount;
                } else {
                    result.push({
                        [x.sessionName + ' Q']: x.totalAmount,
                        [x.sessionName + ' U']: x.userName,
                        date: dateOne,
                        employeeID: x.employeeID,
                        employeeName: x.employeeName,
                        divisionName: x.divisionName,
                        employeeTypeName: x.employeeTypeName,
                        inTime: new Date(x.inTime).toLocaleTimeString('en-US'),
                        jobCode: x.jobCode,
                        jobType: x.jobType === "1" ? 'General' : x.jobType === "2" ? 'Cash' : x.jobType === "3" ? 'OT' : x.jobType === "RSM" ? 'Outgrower' : x.jobType,
                        outTime: new Date(x.inTime).toLocaleTimeString('en-US'),
                        registrationNumber: x.registrationNumber,
                        otHours: x.otHours,
                        allTotal: x.totalAmount,
                        isPlucking: x.isPlucking
                    });
                }
            }
            else {
                var dateOne = x.date.split('T')[0];
                result.push({
                    date: dateOne,
                    employeeID: x.employeeID,
                    employeeName: x.employeeName,
                    divisionName: x.divisionName,
                    employeeTypeName: x.employeeTypeName,
                    inTime: new Date(x.inTime).toLocaleTimeString('en-US'),
                    jobCode: x.jobCode,
                    jobType: x.jobType === "1" ? 'General' : x.jobType === "2" ? 'Cash' : x.jobType === "3" ? 'OT' : x.jobType === "RSM" ? 'Outgrower' : x.jobType,
                    outTime: new Date(x.outTime).toLocaleTimeString('en-US'),
                    isPlucking: x.isPlucking,
                    otHours: x.otHours
                });
            }
        })
        result.sort((a, b) => new Date(b.date) - new Date(a.date));
        setTableData(result);
        setCsvData(result)
    }

    function createFile() {
        var settings = {
            sheetName: 'Employee 360 Report',
            fileName: 'Employee360Report',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData);

        copyOfCsv.forEach(x => {
            x.date = new Date(x.date).toLocaleDateString();
            x.jobType = x.jobType === "1" ? 'General' : x.jobType === "2" ? 'Cash' : x.jobType === "RSM" ? 'Outgrower' : x.jobType;
            x.jobCode = x.jobCode === null ? '-' : x.jobCode;
        });

        copyOfCsv.push({});

        var newRow3 = {
            date: "Employee last transaction date",
        }
        copyOfCsv.push(newRow3);

        chipData.forEach((data, index) => {
            if (data !== "") {
                var newRow = {
                    date: index === 0
                        ? `Plucking Transaction Date : ${data || "-"}`
                        : `Sundry Transaction Date : ${data || "-"}`,
                }
                copyOfCsv.push(newRow);
            }
        });

        var newRow1 = {
            date: "Group :" + groups[monthlyCollectionDetails.groupID],
            employeeName: "Operation Entity : " + estates[monthlyCollectionDetails.estateID],
            employeeTypeName: "Collection Point : " + divisions[monthlyCollectionDetails.divisionID]
        }
        var newRow2 = {
            date: "From Date : " + monthlyCollectionDetails.fromDate,
            employeeName: "To Date : " + monthlyCollectionDetails.toDate,
        }

        copyOfCsv.push({}, newRow1)
        copyOfCsv.push(newRow2)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            divisionID: "0",
            fromDate: new Date().toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0],
            regNumber: "",
            employeeType: "0"
        });
        setIsTableHide(true);
        setErrors("");
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            toDate: searchForm.toDate,
            fromDate: searchForm.fromDate,
            regNumber: searchForm.regNumber,
            employeeType: (searchForm.employeeType === "0") ? "All" : (searchForm.employeeType === "1" ? "General" : "Rsm")
        })
    }

    function createDataTable() {
        if (monthlyCollectionDetails.employeeType !== "0") {
            $('#example').DataTable({
                destroy: true
            });
        } else {
            $('#rsm').DataTable({
                destroy: true
            });
            $('#general').DataTable({
                destroy: true
            });
        }
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Employee 360 Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={monthlyCollectionDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="estateID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={monthlyCollectionDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(
                                                Object.fromEntries(
                                                    Object.entries(estates).filter(([key, value]) => {
                                                        if (key === "0" || !value) return false;
                                                        if (!multipleEstates || Object.keys(multipleEstates).length === 0) {
                                                            return true;
                                                        }
                                                        return Object.values(multipleEstates).includes(value);
                                                    })
                                                )
                                            )}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Collection Point *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={monthlyCollectionDetails.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="toDate">Registration Number*</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="regNumber"
                                            name="regNumber"
                                            type="regNumber"
                                            value={monthlyCollectionDetails.regNumber}
                                            onChange={(e) => handleregNumber(e.target)}
                                            placeholder="Type Registration Number"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["regNumber"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["regNumber"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <InputLabel shrink id="employeeType">Job Type</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="employeeType"
                                            id="employeeType"
                                            name="employeeType"
                                            value={monthlyCollectionDetails.employeeType}
                                            onChange={(e) => handleEmployeeTypeChange(e.target)} >
                                            <MenuItem value="0">--All--</MenuItem>
                                            <MenuItem value="1">Sundry</MenuItem>
                                            <MenuItem value="2">Plucking</MenuItem>
                                        </Select>
                                        {errors["employeeType"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["employeeType"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-3">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            value={monthlyCollectionDetails.fromDate}
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }} />
                                        {errors["fromDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-3">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            value={monthlyCollectionDetails.toDate}
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            inputProps={{
                                                min: toDate.min,
                                                max: toDate.max
                                            }} />
                                        {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pt-4">
                                        <input
                                            type="button"
                                            className="btn btn-primary"
                                            value="Search"
                                            onClick={e => trackPromise(handleSearch(e))} />
                                        <input type="reset"
                                            className="btn btn-warning pull-right"
                                            value="Clear"
                                            onClick={onCancelClick} />
                                    </div>
                                </div>
                            </form>
                            {isTableHide ? null :
                                <div>
                                    {tableData.length != 0 ?
                                        <div style={{ width: '1400px' }}>
                                            <div className="pt-3" style={{ paddingBottom: '10px' }}>
                                                <h6 className="text-left">Employee last transaction date</h6>

                                                <Stack direction="row" spacing={2}>
                                                    <Chip
                                                        label={`${'Plucking'} : ${pluckingTransactionDate}`}
                                                        variant="outlined"
                                                        hidden={pluckingTransactionDate === ""}
                                                        sx={{
                                                            borderColor: "limegreen",
                                                            color: "limegreen",
                                                            fontWeight: "bold",
                                                        }}
                                                    />
                                                    <Chip
                                                        label={`${'Sundry'} : ${sundryTransactionDate}`}
                                                        variant="outlined"
                                                        hidden={sundryTransactionDate === ""}
                                                        sx={{
                                                            borderColor: "limegreen",
                                                            color: "limegreen",
                                                            fontWeight: "bold",
                                                        }}
                                                    />
                                                    <br />
                                                </Stack>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <Box display="flex" justifyContent="flex-end" >
                                                        <TableContainer component={Paper} style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                                            <Table className={classes.table} able size="small" aria-label="sticky table" Table stickyHeader>
                                                                <TableHead style={{ textAlign: 'center', position: 'sticky', top: 0, background: 'white' }}>
                                                                    <TableRow style={{ border: '2px solid black' }}>
                                                                        <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Date</TableCell>
                                                                        <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Emp.Name</TableCell>
                                                                        <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Emp.Type</TableCell>
                                                                        <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Work Division</TableCell>
                                                                        <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>InTime</TableCell>
                                                                        <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>OutTime</TableCell>
                                                                        <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Job Type</TableCell>
                                                                        <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Job Code</TableCell>
                                                                        <TableCell colSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Session 1</TableCell>
                                                                        <TableCell colSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Session 2</TableCell>
                                                                        <TableCell colSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Session 3</TableCell>
                                                                        <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>OT Hours</TableCell>
                                                                    </TableRow>
                                                                    <TableRow style={{ border: '2px solid black' }}>
                                                                        {sessionHeaders.map((data, index) => (
                                                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                                {data.label}
                                                                            </TableCell>
                                                                        ))}
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody >
                                                                    {tableData.map((data, dataIndex) => (
                                                                        <TableRow key={dataIndex} style={{ border: '2px solid black' }}>
                                                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'left' }}>
                                                                                {new Date(data.date).toLocaleDateString()}
                                                                            </TableCell>
                                                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'left' }}>
                                                                                {data.employeeName}
                                                                            </TableCell>
                                                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'left' }}>
                                                                                {data.employeeTypeName}
                                                                            </TableCell>
                                                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'left' }}>
                                                                                {data.divisionName === undefined ? '-' : data.divisionName}
                                                                            </TableCell>
                                                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'left' }}>
                                                                                {data.inTime}
                                                                            </TableCell>
                                                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'left' }}>
                                                                                {data.outTime}
                                                                            </TableCell>
                                                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'left' }}>
                                                                                {data.jobType === "1" ? 'General' : data.jobType === "2" ? 'Cash' : data.jobType == 'RSM' ? 'Outgrower' : data.jobType}
                                                                            </TableCell>
                                                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'left' }}>
                                                                                {data.jobCode === null ? '-' : data.jobCode}
                                                                            </TableCell>
                                                                            {sessionHeaders.map((column) => {
                                                                                const length = column.value.substr(column.value.length - 1);
                                                                                const value = data[column.value];
                                                                                if (length == "Q") {
                                                                                    return (
                                                                                        <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'right' }}>
                                                                                            {value == undefined ? '-' : value == 0 ? '-' : parseInt(value)}
                                                                                        </TableCell>
                                                                                    );
                                                                                }
                                                                                else {
                                                                                    return (
                                                                                        <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'left' }}>
                                                                                            {value == undefined ? '-' : value == 0 ? '-' : (value)}
                                                                                        </TableCell>
                                                                                    );
                                                                                }
                                                                            })}
                                                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'right' }}>
                                                                                {data.otHours === null || data.otHours === 0 ? '-' : data.otHours}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Box>
                                                </div>
                                            </div>
                                        </div>
                                        : null}
                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />
                                        <ReactToPrint
                                            documentTitle={"Employee 360 Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"
                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} tableData={tableData}
                                            groups={groups[monthlyCollectionDetails.groupID]}
                                            estates={estates[monthlyCollectionDetails.estateID]}
                                            division={divisions[monthlyCollectionDetails.divisionID]}
                                            monthlyCollectionDetails={monthlyCollectionDetails}
                                            sessionHeaders={sessionHeaders} chipData={chipData}
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}
